export interface Currency {
  code: string;
  symbol: string;
  name: string;
}

export const CURRENCIES: Currency[] = [
  // Major Reserve Currencies
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "GBP", symbol: "£", name: "British Pound" },
  { code: "JPY", symbol: "¥", name: "Japanese Yen" },
  { code: "CHF", symbol: "CHF", name: "Swiss Franc" },
  
  // North America
  { code: "CAD", symbol: "C$", name: "Canadian Dollar" },
  { code: "MXN", symbol: "MX$", name: "Mexican Peso" },
  { code: "BBD", symbol: "Bds$", name: "Barbadian Dollar" },
  { code: "BMD", symbol: "BD$", name: "Bermudian Dollar" },
  { code: "BSD", symbol: "B$", name: "Bahamian Dollar" },
  { code: "BZD", symbol: "BZ$", name: "Belize Dollar" },
  { code: "GTQ", symbol: "Q", name: "Guatemalan Quetzal" },
  { code: "HNL", symbol: "L", name: "Honduran Lempira" },
  { code: "JMD", symbol: "J$", name: "Jamaican Dollar" },
  { code: "NIO", symbol: "C$", name: "Nicaraguan Córdoba" },
  { code: "PAB", symbol: "B/.", name: "Panamanian Balboa" },
  { code: "TTD", symbol: "TT$", name: "Trinidad and Tobago Dollar" },
  { code: "XCD", symbol: "EC$", name: "East Caribbean Dollar" },
  
  // Asia-Pacific
  { code: "AUD", symbol: "A$", name: "Australian Dollar" },
  { code: "NZD", symbol: "NZ$", name: "New Zealand Dollar" },
  { code: "CNY", symbol: "¥", name: "Chinese Yuan" },
  { code: "HKD", symbol: "HK$", name: "Hong Kong Dollar" },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
  { code: "INR", symbol: "₹", name: "Indian Rupee" },
  { code: "KRW", symbol: "₩", name: "South Korean Won" },
  { code: "THB", symbol: "฿", name: "Thai Baht" },
  { code: "MYR", symbol: "RM", name: "Malaysian Ringgit" },
  { code: "IDR", symbol: "Rp", name: "Indonesian Rupiah" },
  { code: "PHP", symbol: "₱", name: "Philippine Peso" },
  { code: "VND", symbol: "₫", name: "Vietnamese Dong" },
  { code: "AFN", symbol: "؋", name: "Afghan Afghani" },
  { code: "BDT", symbol: "৳", name: "Bangladeshi Taka" },
  { code: "BTN", symbol: "Nu.", name: "Bhutanese Ngultrum" },
  { code: "BND", symbol: "B$", name: "Brunei Dollar" },
  { code: "KHR", symbol: "៛", name: "Cambodian Riel" },
  { code: "FJD", symbol: "FJ$", name: "Fijian Dollar" },
  { code: "LAK", symbol: "₭", name: "Lao Kip" },
  { code: "MMK", symbol: "K", name: "Myanmar Kyat" },
  { code: "MOP", symbol: "MOP$", name: "Macanese Pataca" },
  { code: "MVR", symbol: "Rf", name: "Maldivian Rufiyaa" },
  { code: "NPR", symbol: "₨", name: "Nepalese Rupee" },
  { code: "PKR", symbol: "₨", name: "Pakistani Rupee" },
  { code: "PGK", symbol: "K", name: "Papua New Guinean Kina" },
  { code: "LKR", symbol: "₨", name: "Sri Lankan Rupee" },
  { code: "TWD", symbol: "NT$", name: "New Taiwan Dollar" },
  { code: "TOP", symbol: "T$", name: "Tongan Paʻanga" },
  { code: "VUV", symbol: "Vt", name: "Vanuatu Vatu" },
  { code: "WST", symbol: "WS$", name: "Samoan Tala" },
  
  // Europe
  { code: "SEK", symbol: "kr", name: "Swedish Krona" },
  { code: "NOK", symbol: "kr", name: "Norwegian Krone" },
  { code: "DKK", symbol: "kr", name: "Danish Krone" },
  { code: "PLN", symbol: "zł", name: "Polish Zloty" },
  { code: "CZK", symbol: "Kč", name: "Czech Koruna" },
  { code: "ALL", symbol: "L", name: "Albanian Lek" },
  { code: "AMD", symbol: "֏", name: "Armenian Dram" },
  { code: "AZN", symbol: "₼", name: "Azerbaijani Manat" },
  { code: "BAM", symbol: "КМ", name: "Bosnia-Herzegovina Convertible Mark" },
  { code: "BGN", symbol: "лв", name: "Bulgarian Lev" },
  { code: "BYN", symbol: "Br", name: "Belarusian Ruble" },
  { code: "CHE", symbol: "CHE", name: "WIR Euro" },
  { code: "CHW", symbol: "CHW", name: "WIR Franc" },
  { code: "GEL", symbol: "₾", name: "Georgian Lari" },
  { code: "GIP", symbol: "£", name: "Gibraltar Pound" },
  { code: "HUF", symbol: "Ft", name: "Hungarian Forint" },
  { code: "ISK", symbol: "kr", name: "Icelandic Króna" },
  { code: "MDL", symbol: "L", name: "Moldovan Leu" },
  { code: "MKD", symbol: "ден", name: "Macedonian Denar" },
  { code: "RON", symbol: "lei", name: "Romanian Leu" },
  { code: "RSD", symbol: "дин.", name: "Serbian Dinar" },
  { code: "RUB", symbol: "₽", name: "Russian Ruble" },
  { code: "SHP", symbol: "£", name: "Saint Helena Pound" },
  { code: "TRY", symbol: "₺", name: "Turkish Lira" },
  { code: "UAH", symbol: "₴", name: "Ukrainian Hryvnia" },
  
  // South America
  { code: "BRL", symbol: "R$", name: "Brazilian Real" },
  { code: "ARS", symbol: "AR$", name: "Argentine Peso" },
  { code: "COP", symbol: "COL$", name: "Colombian Peso" },
  { code: "BOB", symbol: "Bs.", name: "Bolivian Boliviano" },
  { code: "BOV", symbol: "BOV", name: "Bolivian Mvdol" },
  { code: "CLF", symbol: "CLF", name: "Chilean Unit of Account (UF)" },
  { code: "CLP", symbol: "$", name: "Chilean Peso" },
  { code: "COU", symbol: "COU", name: "Colombian Real Value Unit" },
  { code: "CRC", symbol: "₡", name: "Costa Rican Colón" },
  { code: "CUC", symbol: "CUC$", name: "Cuban Convertible Peso" },
  { code: "CUP", symbol: "₱", name: "Cuban Peso" },
  { code: "DOP", symbol: "RD$", name: "Dominican Peso" },
  { code: "GYD", symbol: "G$", name: "Guyanese Dollar" },
  { code: "PEN", symbol: "S/", name: "Peruvian Sol" },
  { code: "PYG", symbol: "₲", name: "Paraguayan Guaraní" },
  { code: "SRD", symbol: "SRD", name: "Surinamese Dollar" },
  { code: "UYU", symbol: "$U", name: "Uruguayan Peso" },
  { code: "UYI", symbol: "UYI", name: "Uruguay Peso en Unidades Indexadas" },
  { code: "UYW", symbol: "UYW", name: "Unidad Previsional" },
  { code: "VED", symbol: "VED", name: "Venezuelan Bolívar Soberano" },
  { code: "VES", symbol: "Bs.S", name: "Venezuelan Bolívar" },
  
  // Middle East & Africa
  { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
  { code: "SAR", symbol: "﷼", name: "Saudi Riyal" },
  { code: "ILS", symbol: "₪", name: "Israeli Shekel" },
  { code: "ZAR", symbol: "R", name: "South African Rand" },
  { code: "AOA", symbol: "Kz", name: "Angolan Kwanza" },
  { code: "AWG", symbol: "ƒ", name: "Aruban Florin" },
  { code: "BHD", symbol: "د.ب", name: "Bahraini Dinar" },
  { code: "BIF", symbol: "Fr", name: "Burundian Franc" },
  { code: "CDF", symbol: "FC", name: "Congolese Franc" },
  { code: "CVE", symbol: "Esc", name: "Cape Verdean Escudo" },
  { code: "DJF", symbol: "Fr", name: "Djiboutian Franc" },
  { code: "DZD", symbol: "د.ج", name: "Algerian Dinar" },
  { code: "EGP", symbol: "£", name: "Egyptian Pound" },
  { code: "ERN", symbol: "Nfk", name: "Eritrean Nakfa" },
  { code: "ETB", symbol: "Br", name: "Ethiopian Birr" },
  { code: "FKP", symbol: "£", name: "Falkland Islands Pound" },
  { code: "GHS", symbol: "₵", name: "Ghanaian Cedi" },
  { code: "GMD", symbol: "D", name: "Gambian Dalasi" },
  { code: "GNF", symbol: "Fr", name: "Guinean Franc" },
  { code: "HTG", symbol: "G", name: "Haitian Gourde" },
  { code: "IQD", symbol: "ع.د", name: "Iraqi Dinar" },
  { code: "IRR", symbol: "﷼", name: "Iranian Rial" },
  { code: "JOD", symbol: "د.ا", name: "Jordanian Dinar" },
  { code: "KES", symbol: "Sh", name: "Kenyan Shilling" },
  { code: "KGS", symbol: "с", name: "Kyrgystani Som" },
  { code: "KMF", symbol: "Fr", name: "Comorian Franc" },
  { code: "KPW", symbol: "₩", name: "North Korean Won" },
  { code: "KWD", symbol: "د.ك", name: "Kuwaiti Dinar" },
  { code: "KYD", symbol: "CI$", name: "Cayman Islands Dollar" },
  { code: "KZT", symbol: "₸", name: "Kazakhstani Tenge" },
  { code: "LBP", symbol: "ل.ل", name: "Lebanese Pound" },
  { code: "LRD", symbol: "L$", name: "Liberian Dollar" },
  { code: "LSL", symbol: "L", name: "Lesotho Loti" },
  { code: "LYD", symbol: "ل.د", name: "Libyan Dinar" },
  { code: "MAD", symbol: "د.م.", name: "Moroccan Dirham" },
  { code: "MGA", symbol: "Ar", name: "Malagasy Ariary" },
  { code: "MRU", symbol: "UM", name: "Mauritanian Ouguiya" },
  { code: "MUR", symbol: "₨", name: "Mauritian Rupee" },
  { code: "MWK", symbol: "MK", name: "Malawian Kwacha" },
  { code: "MXV", symbol: "MXV", name: "Mexican Unidad de Inversion" },
  { code: "MZN", symbol: "MT", name: "Mozambican Metical" },
  { code: "NAD", symbol: "N$", name: "Namibian Dollar" },
  { code: "NGN", symbol: "₦", name: "Nigerian Naira" },
  { code: "OMR", symbol: "ر.ع.", name: "Omani Rial" },
  { code: "QAR", symbol: "ر.ق", name: "Qatari Rial" },
  { code: "RWF", symbol: "Fr", name: "Rwandan Franc" },
  { code: "SBD", symbol: "SI$", name: "Solomon Islands Dollar" },
  { code: "SCR", symbol: "₨", name: "Seychellois Rupee" },
  { code: "SDG", symbol: "ج.س.", name: "Sudanese Pound" },
  { code: "SLE", symbol: "SLE", name: "Sierra Leonean Leone" },
  { code: "SLL", symbol: "Le", name: "Sierra Leonean Leone" },
  { code: "SOS", symbol: "Sh", name: "Somali Shilling" },
  { code: "SSP", symbol: "SS£", name: "South Sudanese Pound" },
  { code: "STN", symbol: "Db", name: "São Tomé and Príncipe Dobra" },
  { code: "SVC", symbol: "₡", name: "Salvadoran Colón" },
  { code: "SYP", symbol: "£", name: "Syrian Pound" },
  { code: "SZL", symbol: "L", name: "Swazi Lilangeni" },
  { code: "TJS", symbol: "ЅМ", name: "Tajikistani Somoni" },
  { code: "TMT", symbol: "m", name: "Turkmenistani Manat" },
  { code: "TND", symbol: "د.ت", name: "Tunisian Dinar" },
  { code: "TZS", symbol: "Sh", name: "Tanzanian Shilling" },
  { code: "UGX", symbol: "Sh", name: "Ugandan Shilling" },
  { code: "UZS", symbol: "so'm", name: "Uzbekistani Som" },
  { code: "XAF", symbol: "Fr", name: "Central African CFA Franc" },
  { code: "XOF", symbol: "Fr", name: "West African CFA Franc" },
  { code: "XPF", symbol: "Fr", name: "CFP Franc" },
  { code: "YER", symbol: "﷼", name: "Yemeni Rial" },
  { code: "ZMW", symbol: "ZK", name: "Zambian Kwacha" },
  { code: "ZWL", symbol: "ZWL", name: "Zimbabwean Dollar" },
  
  // Special Purpose & Precious Metals
  { code: "XAG", symbol: "XAG", name: "Silver (Troy Ounce)" },
  { code: "XAU", symbol: "XAU", name: "Gold (Troy Ounce)" },
  { code: "XBA", symbol: "XBA", name: "European Composite Unit" },
  { code: "XBB", symbol: "XBB", name: "European Monetary Unit" },
  { code: "XBC", symbol: "XBC", name: "European Unit of Account 9" },
  { code: "XBD", symbol: "XBD", name: "European Unit of Account 17" },
  { code: "XDR", symbol: "XDR", name: "Special Drawing Rights" },
  { code: "XPD", symbol: "XPD", name: "Palladium (Troy Ounce)" },
  { code: "XPT", symbol: "XPT", name: "Platinum (Troy Ounce)" },
  { code: "XSU", symbol: "XSU", name: "SUCRE" },
  { code: "XTS", symbol: "XTS", name: "Testing Currency Code" },
  { code: "XUA", symbol: "XUA", name: "ADB Unit of Account" },
  { code: "XXX", symbol: "XXX", name: "No Currency" },
  { code: "USN", symbol: "USN", name: "US Dollar (Next day)" },
];

export const DEFAULT_CURRENCY = "USD";

export const getCurrencyByCode = (code: string): Currency | undefined =>
  CURRENCIES.find((c) => c.code === code);
